import clsx from 'clsx'
import { type ReactNode } from 'react'
import { PlusIcon } from '../icons'
import { twMerge } from 'tailwind-merge'

const IconButton = ({
	icon = <PlusIcon />,
	disabled = false,
	onClick,
	additionalClasses = '',
	...props
}: {
	icon: ReactNode
	disabled: boolean
	onClick?: () => void
	additionalClasses?: string
}) => {
	return (
		<button
			className={twMerge(
				disabled === Boolean(true)
					? 'border-textSecondaryLight text-textSecondaryLight dark:border-textSecondaryDark dark:text-textSecondaryDark' // Disabled
					: 'border-textPrimaryLight text-textPrimaryLight hover:border-[#4B4BFF] hover:text-[#4B4BFF] active:border-textSecondaryLight active:text-textSecondaryLight dark:border-textPrimaryDark dark:text-textPrimaryDark hover:dark:border-[#7676FC] hover:dark:text-[#7676FC] active:dark:border-textSecondaryDark active:dark:text-textSecondaryDark',
				'flex h-6 w-6 items-center justify-center border border-solid', // All
				additionalClasses,
			)}
			onClick={() => onClick && onClick()}
			{...props}
		>
			{icon}
		</button>
	)
}

export default IconButton
